// L'attente de l'interrupteur de l'espace tuteur (`tutor_ds`), abandonnée pour un compte : après deux
// relectures de `static-data` sans valeur pour lui, la coquille passe à l'espace d'aujourd'hui. Gardé
// dans le store (`staticData.tutorDsGaveUpFor`) pour que la coquille, l'en-tête de la route `menu` et
// le pont lisent la même valeur (`selectTutorDsReading` rend alors `off` pour ce compte).
export const TUTOR_DS_GAVE_UP = "TUTOR_DS_GAVE_UP"

export const tutorDsGaveUp = (userId) => ({ type: TUTOR_DS_GAVE_UP, userId })
